'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentNetellerAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M74.762 28.895C74.3337 29.1943 73.7122 29.3423 72.8618 29.3423H72.4927H72.0184L72.6651 25.8399H72.9929H73.2853C73.9912 25.8399 74.5069 25.9538 74.8622 26.185C75.1398 26.3664 75.4689 26.7253 75.4689 27.4065C75.4689 28.2273 75.086 28.6688 74.762 28.895ZM24.4508 33.2906H17.9239L18.3458 31.0013H22.4397L22.9049 28.4228H18.8503L19.2423 26.1571H25.7577L24.4508 33.2906ZM78.278 24.192C77.3183 23.5324 75.8662 23.2 73.9623 23.2H68.9759L67.1224 33.291H60.5905L61.0093 31.0016H64.9446L65.4125 28.4302L61.4796 28.4373L61.9008 26.1577H65.9533L66.4925 23.2003H58.2604L56.501 32.7732H53.4824L55.2546 23.2003H50.951L49.1916 32.7732H46.2483L48.0222 23.2003H43.7229L41.8647 33.2913H35.2864L35.7009 31.002H39.6539L40.1194 28.4454L36.1725 28.4417L36.5916 26.1577H40.6892L41.2257 23.2003H15.579L14.1192 31.1971L11.2109 23.2H6.74723L4.34482 36.25H8.60744L10.0613 28.0335L12.8838 36.25H28.1622L30.0194 26.1574H32.41L30.5518 36.25H70.7538L71.9182 29.8785L73.8056 36.25H78.0706L76.1166 31.0441L76.5627 30.9474C77.5455 30.7364 78.315 30.2817 78.8488 29.6005C79.3836 28.9129 79.6552 28.0301 79.6552 26.9697C79.6555 25.7347 79.2057 24.8267 78.278 24.192Z",
          fill: "#8DC640"
        }
      )
    ]
  }
);
const VpPaymentNetellerAsset = forwardRef(PaymentNetellerAsset);

export { VpPaymentNetellerAsset as default };
